import React, { Component } from "react";
import {
    Typography,
    Select,
    MenuItem,
    Grid,
    Switch,
    Snackbar,
    SnackbarContent,
    Divider,
} from "@material-ui/core";
import { connect } from "react-redux";
import { getReportTitles, getSSWPConfigs, getHSQEConfigs } from "./actions";
import styled from "styled-components";
import { hot } from "react-hot-loader";
import ComponentTemplate from "../../../Utilities/TemplateWrappers/ComponentTemplate";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import icons from "./icons.json";

const GridItem = styled(Grid)`
    display: flex !important;
    justify-content: flex-start !important;
`;
class JobPackSelectReports extends Component {
    constructor(props) {
        super(props);
        props.getReportTitles();
        props.getSSWPConfigs();
        props.getHSQEConfigs();
        this.state = {
            profile: props.profile,
            edit: props.edit,
            snackbarState: false,
            snackbarType: "",
            snackbarLabel: "",
            sswpconfigname: "",
            hsqeconfigname: "",
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
        if (
            prevProps.reportTypes !== this.props.reportTypes &&
            this.state.profile
        ) {
            let prof = this.props.profile;
            Object.keys(this.props.reportTypes).map((report_key, i) => {
                if (typeof prof[report_key] === "undefined") {
                    prof[report_key] = "No";
                }
                return null;
            });
            //this.props.callback(prof);
        }
        if (prevState.sswpconfigname !== this.state.sswpconfigname) {
            this.props.callback("sswp_config_name", this.state.sswpconfigname);
        }
    }
    renderDropDown = (key, label) => {
        const { profile } = this.state;
        if (this.state.edit) {
            return (
                <div style={{ display: "flex" }} key={key}>
                    <Typography
                        style={{ marginRight: 20, marginTop: 10 }}
                        variant="body1"
                    >
                        <b>{label}:</b>
                    </Typography>
                    <Select
                        style={{ width: 150 }}
                        value={profile[key] ? profile[key] : "Yes"}
                        onChange={(event) => {
                            this.props.callback(key, event.target.value);
                        }}
                    >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                    </Select>
                </div>
            );
        } else
            return (
                <div style={{ display: "flex" }}>
                    <Typography style={{ marginRight: 40 }} variant="body1">
                        <b>{label}:</b>
                    </Typography>
                    <Typography variant="body1">
                        {profile[key] ? profile[key] : "N/A"}
                    </Typography>
                </div>
            );
    };

    renderSwitch(key, label, icons) {
        if (this.state.edit) {
            let blue_image_path = "";
            try {
                blue_image_path = icons[key].selected;
            } catch (err) {
                blue_image_path = icons["jobpack_icon_empty"].selected; //set default image path
            }

            let grey_image_path = "";
            try {
                grey_image_path = icons[key].deselected;
            } catch (err) {
                grey_image_path = icons["jobpack_icon_empty"].deselected; //set default image path
            }

            return (
                <Grid
                    item
                    lg={2}
                    md={2}
                    sm={2}
                    xs={2}
                    style={{ paddingBottom: "10px" }}
                >
                    <Card style={{ height: "280px" }}>
                        <CardContent style={{textAlign:"center"}}>
                            {this.state.profile[key] === "Yes" ? (
                                <img
                                    src={blue_image_path}
                                    width="130"
                                    height="130"
                                    alt="icon"
                                />
                            ) : (
                                <img
                                    src={grey_image_path}
                                    width="130"
                                    height="130"
                                    alt="icon"
                                />
                            )}
                            <div style={{ marginTop: -13 }}>
                                <Switch
                                    checked={
                                        this.state.profile[key] === "Yes"
                                            ? true
                                            : false
                                    }
                                    color="primary"
                                    onChange={(event) => {
                                        this.props.callback(
                                            key,
                                            event.target.checked ? "Yes" : "No"
                                        );
                                        this.setState({
                                            snackbarState: true,
                                            snackbarType: event.target.checked
                                                ? "add"
                                                : "remove",
                                            snackbarLabel: label,
                                        });
                                    }}
                                />
                            </div>
                            <Typography
                                style={{
                                    width: "100%",
                                    color: "#0188cc",
                                    wordBreak: "break-word",
                                }}
                                variant="body1"
                            >
                                <b>{label}:</b>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            );
        } else {
            let blue_image_path = "";
            try {
                blue_image_path = icons[key].selected;
            } catch (err) {
                blue_image_path = icons["jobpack_icon_empty"].selected; //set default image path
            }

            let grey_image_path = "";
            try {
                grey_image_path = icons[key].deselected;
            } catch (err) {
                grey_image_path = icons["jobpack_icon_empty"].deselected; //set default image path
            }

            return (
                <Grid
                    item
                    lg={2}
                    md={2}
                    sm={2}
                    xs={2}
                    style={{ paddingBottom: "10px" }}
                    key={key}
                >
                    <Card style={{ height: "280px" }}>
                        <CardContent>
                            {this.state.profile[key] === "Yes" ? (
                                <img
                                    src={blue_image_path}
                                    width="130"
                                    height="130"
                                    alt="icon"
                                />
                            ) : (
                                <img
                                    src={grey_image_path}
                                    width="130"
                                    height="130"
                                    alt="icon"
                                />
                            )}
                            <Typography
                                style={{
                                    width: "fit-content",
                                    marginLeft: "56px",
                                }}
                                variant="body1"
                            >
                                {this.state.profile[key] === "Yes" ? (
                                    <CheckIcon
                                        style={{
                                            backgroundColor: "green",
                                            color: "white",
                                        }}
                                    />
                                ) : this.state.profile[key] === "No" ? (
                                    <ClearIcon
                                        style={{
                                            backgroundColor: "red",
                                            color: "white",
                                        }}
                                    />
                                ) : (
                                    "N/A"
                                )}
                            </Typography>
                            <Typography
                                style={{
                                    width: "100%",
                                    color: "#0188cc",
                                    marginTop: "12px",
                                }}
                                variant="body1"
                            >
                                <b>{label}</b>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            );
        }
    }
    uidCallback = (value) => {
        this.props.callback("sswp_config_name", value);
    };

    renderSSWPOptions() {
        const { profile } = this.state;
        const { sswpConfigs, configObj } = this.props;
        let sswpConfigName = "Default";
        sswpConfigs.map((e) => {
            if (e.uid === profile.sswp_config_uid) {
                sswpConfigName = e.name;
            }
            return null;
        });
        if (this.state.edit) {
            let master_sswp_blue_image_path = "";
            try {
                master_sswp_blue_image_path = icons["master_sswp_v2"].selected;
            } catch (err) {
                master_sswp_blue_image_path =
                    icons["jobpack_icon_empty"].selected; //set default image path
            }

            let master_sswp_grey_image_path = "";
            try {
                master_sswp_grey_image_path =
                    icons["master_sswp_v2"].deselected;
            } catch (err) {
                master_sswp_grey_image_path =
                    icons["jobpack_icon_empty"].deselected; //set default image path
            }

            return (
                <>
                    <GridItem item xs={3} style={{ paddingBottom: "10px" }}>
                        <Card style={{ paddingBottom: "5px" }}>
                            <CardContent style={{textAlign:"center"}}>
                                {profile.master_sswp_v2 === "Yes" ? (
                                    <img
                                        src={master_sswp_blue_image_path}
                                        width="130"
                                        height="130"
                                        alt="icon"
                                    />
                                ) : (
                                    <img
                                        src={master_sswp_grey_image_path}
                                        width="130"
                                        height="130"
                                        alt="icon"
                                    />
                                )}
                                <div style={{ marginTop: -13 }}>
                                    <Switch
                                        checked={
                                            profile.master_sswp_v2 === "Yes"
                                                ? true
                                                : false
                                        }
                                        color="primary"
                                        onChange={(event) => {
                                            this.props.callback(
                                                "master_sswp_v2",
                                                event.target.checked
                                                    ? "Yes"
                                                    : "No"
                                            );
                                            this.setState({
                                                snackbarState: true,
                                                snackbarType: event.target
                                                    .checked
                                                    ? "add"
                                                    : "remove",
                                                snackbarLabel: "Master SSWP V2",
                                            });
                                        }}
                                    />
                                </div>
                                <Typography
                                    style={{
                                        width: 150,
                                        color: "#0188cc",
                                    }}
                                    variant="body1"
                                >
                                    <b>Master SSWP V2:</b>
                                </Typography>
                            </CardContent>
                        </Card>
                    </GridItem>

                    {profile.master_sswp_v2 === "Yes" && (
                        <div
                            style={{
                                paddingLeft: "50px",
                                paddingRight: "40px",
                            }}
                            key={"sswp_config"}
                        >
                            <Typography
                                style={{ marginRight: 20 }}
                                variant="body1"
                            >
                                <b>SSWP Config:</b>
                            </Typography>
                            <Select
                                style={{ width: 190 }}
                                value={profile.sswp_config_uid}
                                onChange={(event) => {
                                    if (event.target.value !== "") {
                                        let name =
                                            configObj[event.target.value]
                                                .template_name;
                                        this.setState({ sswpconfigname: name });
                                    } else {
                                        this.setState({ sswpconfigname: "" });
                                    }
                                    this.props.callback(
                                        "sswp_config_uid",
                                        event.target.value
                                    );
                                }}
                            >
                                <MenuItem value="">Default</MenuItem>
                                {sswpConfigs.map((config) => {
                                    return (
                                        <MenuItem
                                            key={config.uid}
                                            value={config.uid}
                                        >
                                            {config.name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </div>
                    )}
                </>
            );
        } else {
            let master_sswp_blue_image_path = "";
            try {
                master_sswp_blue_image_path = icons["master_sswp_v2"].selected;
            } catch (err) {
                master_sswp_blue_image_path =
                    icons["jobpack_icon_empty"].selected; //set default image path
            }

            let master_sswp_grey_image_path = "";
            try {
                master_sswp_grey_image_path =
                    icons["master_sswp_v2"].deselected;
            } catch (err) {
                master_sswp_grey_image_path =
                    icons["jobpack_icon_empty"].deselected; //set default image path
            }

            return (
                <>
                    <GridItem
                        item
                        xs={3}
                        style={{ paddingBottom: "10px" }}
                        key={"master_sswp_v2"}
                    >
                        <Card>
                            <CardContent >
                                {profile.master_sswp_v2 === "Yes" ? (
                                    <img
                                        src={master_sswp_blue_image_path}
                                        width="130"
                                        height="130"
                                        alt="icon"
                                    />
                                ) : (
                                    <img
                                        src={master_sswp_grey_image_path}
                                        width="130"
                                        height="130"
                                        alt="icon"
                                    />
                                )}
                                <Typography
                                    style={{
                                        width: "fit-content",
                                        marginLeft: 65,
                                    }}
                                    variant="body1"
                                >
                                    {profile.master_sswp_v2 === "Yes" ? (
                                        <CheckIcon
                                            style={{
                                                backgroundColor: "green",
                                                color: "white",
                                            }}
                                        />
                                    ) : profile.master_sswp_v2 === "No" ? (
                                        <ClearIcon
                                            style={{
                                                backgroundColor: "red",
                                                color: "white",
                                            }}
                                        />
                                    ) : (
                                        "N/A"
                                    )}
                                </Typography>
                                <Typography
                                    style={{
                                        width: 150,
                                        color: "#0188cc",
                                        marginTop: "12px",
                                    }}
                                    variant="body1"
                                >
                                    <b>Master SSWP V2</b>
                                </Typography>
                                {profile.master_sswp_v2 === "Yes" && (
                                    <Typography variant="body1">
                                        {sswpConfigName}
                                    </Typography>
                                )}
                            </CardContent>
                        </Card>
                    </GridItem>
                </>
            );
        }
    }

    renderHSQEOptions() {
        const { profile } = this.state;
        const { hsqeConfigs } = this.props;
        if (this.state.edit) {
            let custom_blue_image_path = "";
            try {
                custom_blue_image_path = icons["custom_report"].selected;
            } catch (err) {
                custom_blue_image_path = icons["jobpack_icon_empty"].selected; //set default image path
            }

            let custom_grey_image_path = "";
            try {
                custom_grey_image_path = icons["custom_report"].deselected;
            } catch (err) {
                custom_grey_image_path = icons["jobpack_icon_empty"].deselected; //set default image path
            }

            return (
                <>
                    {" "}
                    <GridItem
                        item
                        xs={3}
                        style={{ paddingBottom: "10px" }}
                        key={"master_sswp_v2"}
                    >
                        <Card style={{ paddingRight: "10px" }}>
                            <CardContent style={{textAlign:"center"}}>
                                {profile.custom_report === "Yes" ? (
                                    <img
                                        src={custom_blue_image_path}
                                        width="130"
                                        height="130"
                                        alt="icon"
                                    />
                                ) : (
                                    <img
                                        src={custom_grey_image_path}
                                        width="130"
                                        height="130"
                                        alt="icon"
                                    />
                                )}
                                <div style={{ marginTop: -13 }}>
                                    <Switch
                                        checked={
                                            profile.custom_report === "Yes"
                                                ? true
                                                : false
                                        }
                                        color="primary"
                                        onChange={(event) => {
                                            this.props.callback(
                                                "custom_report",
                                                event.target.checked
                                                    ? "Yes"
                                                    : "No"
                                            );
                                            this.setState({
                                                snackbarState: true,
                                                snackbarType: event.target
                                                    .checked
                                                    ? "add"
                                                    : "remove",
                                                snackbarLabel: "Custom Report",
                                            });
                                        }}
                                    />
                                </div>
                                <Typography
                                    style={{
                                        width: 150,
                                        color: "#0188cc",
                                    }}
                                    variant="body1"
                                >
                                    <b>Custom Reports:</b>
                                </Typography>
                            </CardContent>
                        </Card>
                    </GridItem>
                    {profile.custom_report === "Yes" && (
                        <div
                            style={{ paddingLeft: "40px" }}
                            key={"hsqe_config"}
                        >
                            <Typography
                                style={{ marginRight: 20 }}
                                variant="body1"
                            >
                                <b>HSQE Config:</b>
                            </Typography>
                            <Select
                                style={{ width: 150 }}
                                value={profile.custom_report_configs || []}
                                multiple
                                onChange={(event) => {
                                    this.props.callback(
                                        "custom_report_configs",
                                        event.target.value
                                    );
                                }}
                            >
                                <MenuItem value={null}>Select</MenuItem>
                                {hsqeConfigs.map((config) => {
                                    return (
                                        <MenuItem key={config} value={config}>
                                            {config}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </div>
                    )}
                </>
            );
        } else {
            let custom_blue_image_path = "";
            try {
                custom_blue_image_path = icons["custom_report"].selected;
            } catch (err) {
                custom_blue_image_path = icons["jobpack_icon_empty"].selected; //set default image path
            }

            let custom_grey_image_path = "";
            try {
                custom_grey_image_path = icons["custom_report"].deselected;
            } catch (err) {
                custom_grey_image_path = icons["jobpack_icon_empty"].deselected; //set default image path
            }

            return (
                <>
                    <GridItem
                        item
                        xs={3}
                        style={{ paddingBottom: "10px" }}
                        key={"custom_report"}
                    >
                        <Card>
                            <CardContent>
                                {profile.custom_report === "Yes" ? (
                                    <img
                                        src={custom_blue_image_path}
                                        width="130"
                                        height="130"
                                        alt="icon"
                                    />
                                ) : (
                                    <img
                                        src={custom_grey_image_path}
                                        width="130"
                                        height="130"
                                        alt="icon"
                                    />
                                )}
                                <Typography
                                    style={{
                                        width: "fit-content",
                                        marginLeft: 65,
                                    }}
                                    variant="body1"
                                >
                                    {profile.custom_report === "Yes" ? (
                                        <CheckIcon
                                            style={{
                                                backgroundColor: "green",
                                                color: "white",
                                            }}
                                        />
                                    ) : profile.custom_report === "No" ? (
                                        <ClearIcon
                                            style={{
                                                backgroundColor: "red",
                                                color: "white",
                                            }}
                                        />
                                    ) : (
                                        "N/A"
                                    )}
                                </Typography>
                                <Typography
                                    style={{
                                        width: 150,
                                        color: "#0188cc",
                                        marginTop: "12px",
                                    }}
                                    variant="body1"
                                >
                                    <b>Custom Reports</b>
                                </Typography>
                            </CardContent>
                        </Card>
                    </GridItem>
                    {profile.custom_report === "Yes" && (
                        <GridItem item xs={4} xl={4} key={"custom_report"}>
                            <div style={{ display: "flex" }}>
                                <Typography variant="body1">
                                    <b>HSQE:</b>
                                </Typography>
                                &nbsp;&nbsp;
                                <Typography variant="body1">
                                    {this.state.profile.custom_report_configs &&
                                        this.state.profile.custom_report_configs.map(
                                            (e) => {
                                                return (
                                                    <>
                                                        {e},
                                                        <br />
                                                    </>
                                                );
                                            }
                                        )}
                                </Typography>
                            </div>
                        </GridItem>
                    )}
                </>
            );
        }
    }

    render() {
        const { reportTypes } = this.props;
        return (
            <ComponentTemplate
                isCollapsed={false}
                isCollapsable={true}
                label=" Select Reports For Jobpack "
            >
                <Grid container spacing={2}>
                    {reportTypes &&
                        Object.keys(reportTypes).map((report_key) => {
                            if (
                                report_key !== "master_sswp_v1" &&
                                report_key !== "master_sswp_v2" &&
                                report_key !== "holiday_request" &&
                                report_key !== "timesheets" &&
                                report_key !== "custom_report" &&
                                report_key !==
                                    "dcc_chso_dcc_chso_covid_compliance_checklist" &&
                                report_key !== "tm_slg_checklist"
                            ) {
                                return this.renderSwitch(
                                    report_key,
                                    reportTypes[report_key],
                                    icons
                                );
                            } else return null;
                        })}
                </Grid>
                <Divider style={{ marginBottom: "10px" }} />
                <h5>
                    <b>Master SSWP/Custom Reports</b>
                </h5>
                <Grid container spacing={2}>
                    {this.props.sswpConfigs && this.renderSSWPOptions()}
                    {this.props.hsqeConfigs && this.renderHSQEOptions()}
                </Grid>
                <SelectedSnackbar
                    state={this.state.snackbarState}
                    type={this.state.snackbarType}
                    label={this.state.snackbarLabel}
                    onClose={() => {
                        this.setState({
                            ...this.state,
                            snackbarState: false,
                            snackbarType: "",
                            snackbarLabel: "",
                        });
                    }}
                />
            </ComponentTemplate>
        );
    }
}

export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const {
                selectReportTitles,
                selectSSWPConfigInfo,
                selectSSWPConfigs,
                templateList,
            } = selectors;
            return {
                sswpConfigs: selectSSWPConfigInfo(store),
                reportTypes: selectReportTitles(store),
                configObj: selectSSWPConfigs(store),
                hsqeConfigs: templateList(store),
            };
        },
        { getReportTitles, getSSWPConfigs, getHSQEConfigs }
    )(JobPackSelectReports)
);

const SelectedSnackbar = ({ state, type, label, onClose }) => {
    return (
        <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            open={state}
            autoHideDuration={3000}
            onClose={onClose}
        >
            <SnackbarContent
                style={{
                    backgroundColor:
                        type === "add"
                            ? "green"
                            : type === "remove"
                            ? "red"
                            : "white",
                    color: "white",
                }}
                message={
                    (type === "add" ? `Selected` : `Removed`) +
                    ` ${label} As Required Report For This JobPack`
                }
            />
        </Snackbar>
    );
};
